export enum ApprovalFilterEnum {
    APPROVED = 'Approved',
    PENDING = 'Pending',
    REJECTED = 'Rejected',
    ALL = 'All'
}
